import { lazy } from 'react';

const PhoneVerificationCodeModal = lazy(() =>
  import('./modals/PhoneVerificationCodeModal'),
);

export default {
  PHONE_VERIFICATION_CODE_MODAL: PhoneVerificationCodeModal,
};
